/*@ngInject*/
const SectionTemplateActionsUtil = function ($rootScope, $stateParams, $state, $q, sectionTemplateRepository, loadingBarHandler, configurationMediator, sectionTemplateEditorModel, modalUtil, coreConstant) {

    this.reloadSectionTemplateRules = function (validate) {
        return sectionTemplateRepository.reloadSectionTemplateRules(validate);
    };

    this.saveSectionTemplate = function (translations, sectionTemplate) {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSectionTemplate.loadingBar'));
        return configurationMediator.saveSectionTemplate(sectionTemplate).then(function (savedSectionTemplate) {
            const quoteDocumentTemplateFile = sectionTemplateEditorModel.getQuoteDocumentTemplateFile(sectionTemplate.id);

            if (sectionTemplateEditorModel.hasUnsavedQuoteDocumentTemplateFile(sectionTemplate.id)) {
                return configurationMediator.uploadQuoteDocumentTemplateFile(savedSectionTemplate, quoteDocumentTemplateFile).then(() => {
                    return concludeSaveSectionTemplate(translations, savedSectionTemplate);
                });
            } else {
                return concludeSaveSectionTemplate(translations, savedSectionTemplate);
            }
        });
    };

    function concludeSaveSectionTemplate(translations, savedSectionTemplate) {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSectionTemplate.savingSectionTemplateSuccessLoadingBar'));
        $stateParams.sectionTemplateId = savedSectionTemplate.id;
        sectionTemplateEditorModel.updateSectionTemplate(savedSectionTemplate);
        return $q.when(savedSectionTemplate);
    }

    this.discard = function (translations) {
        modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
            sectionTemplateEditorModel.setUnsavedPropertiesChanges($stateParams.sectionTemplateId, false);
            sectionTemplateEditorModel.setUnsavedRuleChanges($stateParams.sectionTemplateId, false);
            sectionTemplateEditorModel.setUnsavedQuoteDocumentTemplateFile($stateParams.sectionTemplateId, false);
            if ($stateParams.sectionTemplateId && $stateParams.sectionTemplateId !== '-1') {
                $state.reload();
            } else {
                $state.go('configuration.sectionTemplateBrowser', {});
            }
        });
    };

    this.delete = function (translations, sectionTemplateId) {
        modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.deleteConfirmation', null, true, function () {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteConfirmation.loadingBar'));
            return configurationMediator.deleteSectionTemplate(sectionTemplateId).then(function () {
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteConfirmation.success'));
                $state.go('configuration.sectionTemplateBrowser', {});
            });
        });
    };

    this.markInProduction = function (translations, sectionTemplateId) {
        modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.markInProductionConfirmation', null, true, function () {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'markInProductionConfirmation.loadingBar'));
            return configurationMediator.markSectionTemplateInProduction(sectionTemplateId).then(function (updatedSectionTemplate) {
                sectionTemplateEditorModel.updateSectionTemplate(updatedSectionTemplate);
                $state.reload();
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'markInProductionConfirmation.success'));
            });
        });
    };
};

angular.module('ums.configuration')
    .service('sectionTemplateActionsUtil', SectionTemplateActionsUtil);
